import TestingCache from './testingCache';
var cache = new TestingCache();
export default function wrapCallback(callback, event) {
    cache.saveEvent(event);
    if (!callback || typeof callback !== 'function') {
        return null;
    }
    return function () {
        callback(event);
    };
}
